import omit from 'ramda/src/omit'
import map from 'ramda/src/map'
import evolve from 'ramda/src/evolve'
import mapObjIndexed from 'ramda/src/mapObjIndexed'
import compose from 'ramda/src/compose'
import when from 'ramda/src/when'
import equals from 'ramda/src/equals'
import converge from 'ramda/src/converge'
import identity from 'ramda/src/identity'
import objOf from 'ramda/src/objOf'
import pick from 'ramda/src/pick'
import prop from 'ramda/src/prop'

const omitModelKeys = compose(objOf('model'), pick(['id', 'limits', 'total_limits']), prop('model'))

const compressDoorController =
  converge(
    Object.assign, [
      identity,
      omitModelKeys
    ]
  )

const omittedKeys = ['overlay', 'remove', 'marker', 'fillMarker', 'showTooltip']

const compressEntity = key =>
  compose(
    when(
      _ => equals(key, 'doorControllers'),
      compressDoorController
    ),
    omit(omittedKeys)
  )

export default mapObjIndexed((type, key) => evolve({ byId: map(compressEntity(key)) }, type))



// WEBPACK FOOTER //
// ./src/helpers/projects/compressEntities.js